import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';

import { DialogZipcodeComponent } from './dialog-zipcode.component';

import { AppSheetContractorComponent } from '../chrome/app-sheet-contractor.component';

import {
  AuthenticationService,
  ContactApiService,
  ContractorServiceZipApiService,
  CrossSiteNavigationService
} from '../data-services/index';

import {
  IContact, IUser, IHelp, HelpApiService, IContactInput,
  IContractorServiceZip, IContractorServiceZipInput, UtilityService, AppLoadService, ContractorApiService
} from '@ebb-v2/ebb-integration';
import { DialogDeleteZipcodeComponent } from './dialog-deletezipcode.component';
import { DialogPortalContractorReviewsComponent } from '../grant/dialog/dialog-contractorreviews.component';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { cloneDeep } from '@apollo/client/utilities';

@Component({
  selector: 'ebb-portal-directory',
  templateUrl: './directory.component.html'
})
export class DirectoryComponent implements OnInit {
  public currentUser: IUser;
  public currentContact: IContact;
  public currentContractorServiceZip: IContractorServiceZip[];
  public listHelp: IHelp[] = [];

  public formIncludeInDirectory: FormGroup;
  public formEssIncludeInDirectory: FormGroup;

  public textContractorDirectoryFemaComplete: string;
  public textContractorDirectoryFemaIncomplete: string;

  public businessLogo: string;
  public businessLogoRoot: string;
  public genericLogo: string;
  public showMore = false;

  public ebbTrainingUrl: string;
  public essTrainingUrl: string;

  constructor(
    private readonly apiAppSettings: AppLoadService,
    private readonly authenticationService: AuthenticationService,
    private readonly xSiteNavigationService: CrossSiteNavigationService,
    private readonly apiContact: ContactApiService,
    private readonly apiContractorServiceZip: ContractorServiceZipApiService,
    private readonly apiHelp: HelpApiService,
    private readonly router: Router,
    private readonly fb: FormBuilder,
    private readonly infoSheet: MatBottomSheet,
    private readonly dialogProxy: MatDialog,
    private readonly diadeletelogProxy: MatDialog,
    public readonly util: UtilityService,
    private readonly dialogContractorReviews: MatDialog,
    private apiContractor: ContractorApiService,
  ) {
    const envSettings = this.apiAppSettings.readEnvironSettings();

    this.genericLogo = `${envSettings.uriEbbAssets}/images/ContractorLogo.png`;
    this.businessLogoRoot = `${envSettings.uriApiRoot}/files/contractorLogo/`;
  }

  ngOnInit() {
    this.currentUser = this.authenticationService.currentUserValue;
    this.initializeForms();
    this.getContact(this.currentUser.id);
    this.getContactorServiceZip(this.currentUser.id);
    this.loadHelpText();

    this.ebbTrainingUrl = this.xSiteNavigationService.ebbSiteUrl(
      '/Contractors-Design-Professionals/FEMA-Education-Course', this.currentUser
    );
    this.essTrainingUrl = this.xSiteNavigationService.essSiteUrl(
      '/Contractors-Design-Professionals/FEMA-Education-Course', this.currentUser
    );
  }
  public onShowReviews(event) : void {
    event.preventDefault();
    this.apiContractor
      .getContractorReviews(this.currentUser.id)
      .subscribe(
        data => {
          const dialogRef = this.dialogContractorReviews.open(DialogPortalContractorReviewsComponent, {
            width: '600px',
            height: '600px',
            data: {
              reviews: data,
              name: this.currentContact.businessName,
              licenseNo: this.currentContact.contractorLicenseNumber,
              previewLimit: 3,
              contractor:true,
              
            }
          });
        },
        error => console.warn(error),
      );
  }
  private initializeForms(): void {
    this.formIncludeInDirectory = this.fb.group({
      withdrawFromEbbDirectory: ''
    });
    this.formEssIncludeInDirectory = this.fb.group({
      withdrawFromEssDirectory: ''
    });
  }

  private getContact(currentId: string): void {
    this.apiContact.getContact(currentId,true).subscribe(
      data => {
        this.currentContact = cloneDeep(data);
        this.currentContact.id
          ? (this.businessLogo = `${this.businessLogoRoot}${
              this.currentUser.id
            }`)
          : (this.businessLogo = this.genericLogo);
        this.formIncludeInDirectory
          .get('withdrawFromEbbDirectory')
          .setValue(!this.currentContact.contractorInDirectory);
            this.formEssIncludeInDirectory
              .get('withdrawFromEssDirectory')
              .setValue(
                !this.currentContact.essContractorInDirectory
              );

      },
      error =>
        console.warn(`ERROR: ContractorDirectory.getContact() - ${error}`)
    );
  }

  public getContractorImageError(event) {
    event.target.src = this.genericLogo;
  }

  private getContactorServiceZip(currentId: string): void {
    this.apiContractorServiceZip.get(currentId).subscribe(
      _data => {
        var data = cloneDeep(_data);
        this.currentContractorServiceZip = data.sort((a, b) =>
          a.zipCode > b.zipCode ? 1 : -1
        );
      },
      error =>
        console.warn(
          `ERROR: ContractorDirectory.getContactorServiceZip() - ${error}`
        )
    );
  }

  private loadHelpText(): void {
    this.apiHelp.getList().subscribe(
      _data => {
        var data = cloneDeep(_data);
        this.listHelp = [...data];
        const indexContractorDirectoryFemaComplete = this.listHelp.findIndex(
          i => i.name.toLowerCase() === 'contractordirectoryfemacomplete'
        );
        if (indexContractorDirectoryFemaComplete >= 0)
          this.textContractorDirectoryFemaComplete = this.listHelp[
            indexContractorDirectoryFemaComplete
          ].answer;

        const indexContractorDirectoryFemaIncomplete = this.listHelp.findIndex(
          i => i.name.toLowerCase() === 'contractordirectoryfemaincomplete'
        );
        if (indexContractorDirectoryFemaIncomplete >= 0)
          this.textContractorDirectoryFemaIncomplete = this.listHelp[
            indexContractorDirectoryFemaIncomplete
          ].answer;
      },
      error => console.log(error)
    );
  }

  public onChangeIncludeInDirectory(event, directoryType: string): void {
    const excludeFromDirectory = event.checked;
    const inputListing: IContactInput = {} as IContactInput;
    if (directoryType === 'EBB') {
      inputListing.contractorInDirectory = !excludeFromDirectory;
    }
    if (directoryType === 'ESS') {
      inputListing.essContractorInDirectory = !excludeFromDirectory;
    }
    this.apiContact.updateContact(inputListing).subscribe(
      _data => {
        var data = cloneDeep(_data);
       if (directoryType === 'EBB') {

        this.formIncludeInDirectory
          .get('withdrawFromEbbDirectory')
          .setValue(excludeFromDirectory);
        }
            if (directoryType === 'ESS') {
              this.formEssIncludeInDirectory
                .get('withdrawFromEbbDirectory')
                .setValue(excludeFromDirectory);
            }

      },
      error =>
        console.warn(
          `ERROR: Directory.onChangeIncludeDirectory ${JSON.stringify(error)}`
        )
    );
  }

  public showContractorDirectory(programTypes: string): void {
    const sheetRef = this.infoSheet.open(AppSheetContractorComponent, {
      data: {
        isPortal: false, //contractor view of public search, so false
        programTypes: programTypes
      }
    });
  }

  public onToggleMoreContractor(event): void {
    event.preventDefault();
    this.showMore = this.showMore ? false : true;
  }

  public formatLink(value: string) {
    if (value) {
      value = value.toLowerCase();
      if (value.startsWith('http')) {
        return value;
      } else {
        return `http://${value}`;
      }
    }
    return '';
  }

  public addServiceZipCode(): void {
    const dialogRef = this.dialogProxy.open(DialogZipcodeComponent, {
      width: '90vw',
      maxWidth: '500px'
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        result.forEach(i => {
          if (
            this.currentContractorServiceZip.findIndex(l => l.name === i.name) <
            0
          ) {
            const contractorServiceZip: IContractorServiceZipInput = {} as IContractorServiceZipInput;

            contractorServiceZip._Ebb_ContactId = this.currentUser.id;
            contractorServiceZip.name = i.name;
            contractorServiceZip.zipCode = i.name;

            this.apiContractorServiceZip
              .save(contractorServiceZip)
              .subscribe(
                data => this.getContactorServiceZip(this.currentUser.id),
                error =>
                  console.warn(
                    `ERROR: Add new service ZIP ${JSON.stringify(error)}`
                  )
              );
          }
        });
      }
    });
  }
  public deleteServiceZipCode(): void {
    const dialogDeleteRef = this.diadeletelogProxy.open(
      DialogDeleteZipcodeComponent,
      {
        width: '90vw',
        maxWidth: '500px',
        data: this.currentContractorServiceZip
      }
    );

    dialogDeleteRef.afterClosed().subscribe(result => {
      if (result) {
        result.forEach(i => {
          const record = this.currentContractorServiceZip.filter(
            l => l.name === i.name
          );
          if (record.length > 0) {
            const contractorServiceZip: IContractorServiceZipInput = {} as IContractorServiceZipInput;
            contractorServiceZip.id = record[0].id;
            contractorServiceZip._Ebb_ContactId = record[0]._Ebb_ContactId;
            contractorServiceZip.name = record[0].name;
            contractorServiceZip.zipCode = record[0].zipCode;

            this.apiContractorServiceZip
              .delete(contractorServiceZip)
              .subscribe(
                data => this.getContactorServiceZip(this.currentUser.id),
                error =>
                  console.warn(
                    `ERROR: Remove service ZIP ${JSON.stringify(error)}`
                  )
              );
          }
        });
      }
    });
  }
  public navigateToAccount(): void {
    this.router.navigate([`/account`]);
  }
  public redirectToESSTraining() {
    this.router.navigate(['/trainingess']);
  }
  public  redirectToEBBTraining() {
    this.router.navigate(['/trainingebb']);
  }
}
